import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { Endpoints } from '../../apis';
import { InvokeActionModel } from '../../apis/v1/instances/model';
import { getErrorMessage } from '@xver/utils/error';
import { INSTANCE_LIST_QUERY_KEY } from './useInstanceListQuery';

export function useInvokeActionMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, action }: { id: number; action: InvokeActionModel }) =>
            Endpoints.v1.Instances.invokeAction(id, action),
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: INSTANCE_LIST_QUERY_KEY });
            queryClient.invalidateQueries({
                queryKey: ['api.v1.instances.get', variables?.id],
            });

            const action = variables?.action;
            switch (action) {
                case 'start':
                    notifications.show({
                        title: t('instance.startingTitle'),
                        message: t('instance.startingMessage'),
                        icon: <IconCheck size={32} color={'#00ff00'} />,
                    });
                    break;
                case 'shutdown':
                    notifications.show({
                        title: t('instance.shuttingDownTitle'),
                        message: t('instance.shuttingDownMessage'),
                        icon: <IconCheck size={32} color={'#00ff00'} />,
                    });
                    break;
                case 'reboot':
                    notifications.show({
                        title: t('instance.rebootingTitle'),
                        message: t('instance.rebootingMessage'),
                        icon: <IconCheck size={32} color={'#00ff00'} />,
                    });
                    break;
                default:
            }
        },
        onError: (error: any) => {
            notifications.show({
                title: t('instance.actionFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
